<div class="row files-container">
  <ng-container
    *ngFor="let file of files"
  >
    <div class="col-lg-3 col-md-6 col-sm-12 file-container">
      <ng-container *ngIf="file['fileType'] === 'img'">
        <div class="img" (click)="onOpenFile(file['fileID'])">
          <img
            [src]="apiUrl + file['fileLink'] + '?size=150x150'"
            alt=""
          />
          <div class="hover">
            <i class="pi pi-external-link"></i>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          file['fileType'] === 'doc' ||
          file['fileType'] === 'sign' ||
          file['fileType'] === 'arch'
        "
      >
        <div
          class="doc"
          (click)="
            onOpenFile(
              file['reqScript']
                ? {
                    fileID: file['fileID'],
                    reqScript: file['reqScript']
                  }
                : file['fileID']
            )
          "
        >
          <i *ngIf="file['fileType'] === 'doc'" class="icon-link pi pi-file"></i>
          <i *ngIf="file['fileType'] === 'sign'" class="icon-link pi pi-check-circle"></i>
          <i *ngIf="file['fileType'] === 'arch'" class="icon-link pi pi-inbox"></i>
          <div class="hover">
            <i class="pi pi-external-link"></i>
          </div>
        </div>
      </ng-container>
      <div class="file-name">{{ file['fileName'] }}</div>
    </div>
  </ng-container>
</div>
